/**
 * created by ban yan
 *
 */
import React, {Component} from 'react';
import {Input, Form, Modal, Checkbox, Icon, Select} from 'antd';
import BaseComponent from "../../../../base/BaseComponent";
import BaseTable from "../../../components/baseTable/BaseTable";

import {Scrollbars} from "react-custom-scrollbars";
import {uuid} from "../../../../utils";

const {Search} = Input;


class MediaList extends BaseComponent {
    static defaultProps = {
        onChange: (data) => {

        }
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            visible: false,//控制弹框显示隐藏
            deptId: window.currentUser.deptIds,
            mediaData: [],//请求拿到的数据
            useMediaList: [],  //选中暂存的数据
            confirmMediaList: [],//确定选中的数据
            indeterminate: true,
            checkedAll: false,
            endDataList: [],//抛出的新对象数组
            searchVal: '',
            saveSearchVal: '',
            onSearchMediaList: [],
            mediaCopyData: []//拷贝初始化的列表数据
            // modalKey: uuid(),
        };
    }

    componentDidMount() {
        // confirmMediaList: this.props.itemValue || []
        this.getMediaList()
    }

    getMediaList = () => {
        this.request({//请求发布媒体列表
            url: '/cm-sites-pms/media/getMediaByDept',
            body: {'deptId': this.state.deptId},
            callBack: (res) => {
                let list = [];
                if (res && res.length) {
                    res.filter((item)=>{
                        if(item.mediaTypeCode==='material' || item.mediaTypeCode==='webNews'){
                            list.push(item)
                        }
                        return list
                    })
                }
                let confirmMediaList = []
                if (this.props.itemValue && this.props.itemValue.length) {
                    confirmMediaList = list.filter(item => this.props.itemValue.some(item2 => item2.id === item.id))
                }
                this.setState({
                    mediaData: list,
                    mediaCopyData: list,
                    confirmMediaList
                })
            }
        })
    }

    render() {
        return (
            <div>

                <Form.Item label={this.props.label} required={this.props.required}
                           style={{display: "flex", alignItems: "center"}} labelCol={{span: 5}} wrapperCol={{span: 20}}>
                    <div className={'select'} style={{position: "relative", width: 672}}>
                        <Select mode="multiple"
                                open={false}
                                value={this.state.confirmMediaList && this.state.confirmMediaList.map((item, index) => {
                                    return item.name
                                })}
                                placeholder={this.props.placeholder}
                                onDropdownVisibleChange={this.showModal}
                                // onChange={this.selectValue}
                                onDeselect={(value) => {
                                    //删除确定列表中的数据
                                    this.state.confirmMediaList = this.state.confirmMediaList.filter(item=>item.name != value)
                                    // this.state.confirmMediaList.length && this.state.confirmMediaList.forEach((item, index) => {
                                    //     if (item.name === value) {
                                    //         this.state.confirmMediaList.splice(index, 1);
                                    //     }
                                    // })
                                    this.setState({});
                                }}
                                style={{width: 655}}>
                        </Select>
                        <Icon type="right" style={{
                            position: "absolute",
                            top: 10,
                            right: 20,
                            color: "rgba(0, 0, 0, 0.25)"
                        }}/>
                    </div>
                    <style>{
                        `
                        .select .ant-select .ant-select-selection--multiple{background:#F6F8FD} 
                        `
                    }
                    </style>
                </Form.Item>

                <div id='publishMedia'>
                    {/*弹窗*/}

                    <Modal
                        title="选择媒体"
                        visible={this.state.visible}
                        onOk={() => {
                            this.onClickConfirm(this.state.useMediaList)
                            this.hideModal();
                        }}
                        // key={this.state.modalKey}
                        onCancel={this.hideModal}
                        okText="确认"
                        cancelText="取消"
                        width={1200}
                    >

                        {/*搜索*/}
                        {this.renderSearch()}
                        <Scrollbars
                            autoHeight={true}
                            autoHeightMax={600}
                        >
                            <BaseTable columns={this.getColumns()} dataSource={this.state.mediaData}/>
                        </Scrollbars>

                    </Modal>

                </div>


            </div>
        );
    }

    //搜索框
    renderSearch = () => {
        return (
            <div style={{display: 'flex', justifyContent: 'right', marginBottom: 20}}>
                <Search
                    value={this.state.saveSearchVal}
                    placeholder="请输入"
                    onSearch={value => this.onSearch(value)}
                    style={{width: 250}}
                    onChange={e => {
                        this.setState({saveSearchVal: e.target.value})
                    }}
                />
            </div>
        )
    };

    //点击搜索
    onSearch(value) {
        if (value) {
            let onSearchMediaList = this.state.mediaCopyData.filter(r => r.name.indexOf(value) > -1)
            this.setState({mediaData: onSearchMediaList, onSearchMediaList, searchVal: value}, () => {
                console.log(this.state.mediaData)
            })
        } else {
            this.setState({searchVal: '', mediaData: this.state.mediaCopyData}, () => {
                // this.getMediaList()
            })
        }
    }

    //点击确定
    onClickConfirm = () => {
        let newData = JSON.parse(JSON.stringify(this.state.useMediaList));
        let arr = [];
        newData && newData.forEach((item) => {
            arr.push({code: item.id, name: item.name})
        })
        this.setState({
            confirmMediaList: newData,
            endDataList: arr,
        }, () => {
            // this.props.callBack&& this.props.callBack(this.state.endDataList)
            this.props.callBack && this.props.callBack(this.state.confirmMediaList)
            console.log('确定选中的数据', this.state.confirmMediaList)
        })
    }


    //拿到当前所选列表
    //根据checked选中或未选中，重新组织当前所选列表
    //checked是true，则把当前record push到当前所选列表zhong ,如果是false则通过filter把当前数据从所选列表中过滤掉并重新赋值
    //刷新页面

    weight = (list) => {
        let newList = [];
        list.forEach(item => {
            if (newList.every(item2 => item2.id !== item.id)) {
                newList.push(item)
            }
        })
        return newList
    };
    //取消全选
    cancel = (list) => {
        let useMediaList = this.state.useMediaList
        let newList = []
        useMediaList.forEach(item => {
            if (list.every(item2 => item2.id !== item.id)) {
                newList.push(item)
            }
        })
        return newList
    }

    //全选
    checkedAllChange(checked) {
        if (checked) {
            this.setState({useMediaList: this.weight([...this.state.mediaData, ...this.state.useMediaList])})
        } else {
            this.setState({useMediaList: this.cancel([...this.state.mediaData])});
        }
    }

    simpleCheckedChange(checked, record) {
        if (checked) {
            this.state.useMediaList.push(record);
        } else {
            this.state.useMediaList = this.state.useMediaList.filter(item => item.id !== record.id);
        }
        this.setState({});
    }


    //表格列
    getColumns = () => {
        return [
            {
                title: (() => {
                    //拿到当前所选的所有数据
                    //拿到当前列表所有数据
                    //比对两个列表长度是否相等
                    //如果长度相等则为全选
                    //如果长度不相等，并且所选有数据，则为半选
                    //最后，当前所选数据为空，则为不选
                    let checkedAll = false;
                    let checkedLength = 0;
                    let indeterminate = false;
                    if (this.state.mediaData && this.state.mediaData.length > 0) {
                        checkedAll = this.state.mediaData.every(item => this.state.useMediaList.some(item2 => item2.id === item.id));
                        indeterminate = !checkedAll && this.state.mediaData.some(item => this.state.useMediaList.some(item2 => item2.id === item.id))
                    } else {
                        checkedAll = false;
                        indeterminate = !checkedAll && this.state.mediaData.some(item => this.state.useMediaList.some(item2 => item2.id === item.id))
                    }
                    return (
                        <Checkbox checked={checkedAll} indeterminate={indeterminate} onChange={(e) => {
                            this.checkedAllChange(e.target.checked);
                        }}/>
                    )
                })(),
                align: 'center',
                width: 50,
                key: "checked",
                render: (text, record) => {
                    //拿到当前这条数据record
                    //拿到当前所选所有数据
                    //判断当前数据是否在所选列表中，如在则为选中，否则为未选中
                    let checked = false;
                    let useMediaList = this.state.useMediaList;
                    if (useMediaList && useMediaList.length) {
                        checked = useMediaList.some(item => item.id === record.id);
                    }
                    return (
                        <div>
                            <Checkbox checked={checked} onChange={(e) => {
                                this.simpleCheckedChange(e.target.checked, record)
                            }}/>
                        </div>
                    )
                }
            },
            {
                title: '媒体名称',
                dataIndex: 'name',
                width: 300,
            },
            {
                title: '媒体编码',
                dataIndex: 'mediaTypeCode',
                width: 200,
            },
            {
                title: '媒体类型',
                dataIndex: 'mediaType',
                width: 200,
                render: (text, record) => {
                    return (
                        <span>{
                            record.mediaTypeCode === 'kuaishou' ? '快手' :
                                record.mediaTypeCode === 'douyin' ? '抖音' :
                                    record.mediaTypeCode === 'material' ? '公众号' :
                                        record.mediaTypeCode === 'webNews' ? '网站' :
                                            record.mediaTypeCode === 'weibo' ? '微博' :
                                                record.mediaTypeCode === 'baijiahao' ? '百家号' :
                                                    '-'}
                        </span>
                    )
                }
            },

        ];

    };

    hideModal = () => {
        // let newData = JSON.parse(JSON.stringify(this.state.useMediaList));
        // let arr = [];
        // newData && newData.forEach((item) => {
        //     arr.push({code: item.id, name: item.name})
        // })
        this.setState({
            // confirmMediaList: newData,
            // endDataList: arr,
            modalKey: uuid(),
            visible: false,
        },()=>{
            // this.props.callBack && this.props.callBack(this.state.confirmMediaList)
        });
    };

    showModal = () => {
        let data = JSON.parse(JSON.stringify(this.state.confirmMediaList));
        this.setState({
            useMediaList: data,
            visible: true,
            onSearchMediaList: [],
            searchVal: '',
            saveSearchVal: ''
        }, () => {
            this.refreshChecked();
            this.onSearch();
            // this.getMediaList()
        });
    };

    //refresChecked
    refreshChecked() {
        let useMediaList = this.state.useMediaList;
        if (useMediaList && useMediaList.length && this.state.mediaData && this.state.mediaData.length) {
            this.state.mediaData.forEach((item, index) => {
                this.state.mediaData[index].checked = useMediaList.some(item2 => item2.id === item.id);
            })
        }
        this.setState({})
    }

}


export default MediaList
